<template>
    <div class="warninglv">
        <el-row class="Description">
            <el-col>
                <div class="Breadcrumb">
                    <div>

                        <el-button @click="gotoBefore()" type="primary" plain round class="back">Back</el-button>
                    </div>
                    <!-- <div class="father">Alarm Center</div>
                    <div class="path">/</div> -->
                    <div class="now">Alarm History Management</div>
                </div>

                <el-input class="warningInput" v-model="queryInfo.keywords"
                    placeholder="Please enter key words to search" suffix-icon="el-icon-search" clearable></el-input>

                <span class="state">Alarm Level：</span>
                <el-select class="stateSelect" ref="select1" @blur="clickOutSide1()" v-model="queryInfo.level"
                    placeholder="select" clearable>
                    <el-option v-for="item in levellist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">Alarm Type：</span>
                <el-select class="stateSelect" ref="select2" @blur="clickOutSide2()" v-model="queryInfo.type"
                    placeholder="select" clearable>
                    <el-option v-for="item in typelist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">System：</span>
                <el-select class="stateSelect" ref="select3" @blur="clickOutSide3()" v-model="queryInfo.module"
                    placeholder="select" clearable>
                    <el-option v-for="item in modulelist" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <span class="state">Current State：</span>
                <el-select class="stateSelect" ref="select4" @blur="clickOutSide4()" v-model="queryInfo.status"
                    placeholder="select" clearable>
                    <el-option v-for="item in selectOption1" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="serchAllRuleData()" class="searchButton" round>Search</el-button>
                <el-button @click="resetSearch()" class="resetButton" round>Reset</el-button>
                <br />
                <div class="btn_box">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        <div class="check_box">
                            <el-checkbox v-model="checked" @change="clickcheck()">All</el-checkbox>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <div v-for="item in iconlist" class="iconbox" :style="'color:' + item.color" :key="item.id"
                                @click="openmylog(item.id)">
                                <img :src="item.img" alt="">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>

            </el-col>
        </el-row>
        <div class="center">
            <el-table ref="usertable" :data="warninglist" style="width: 100%">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="id" label="Alarm ID" width="100" align="center"></el-table-column>
                <el-table-column prop="name" label="Alarm Name" align="center"></el-table-column>
                <el-table-column prop="level_name" label="Alarm Level" align="center"></el-table-column>
                <el-table-column prop="type_name" label="Alarm Type" align="center"></el-table-column>
                <el-table-column prop="module_name" label="System" align="center"></el-table-column>
                <el-table-column prop="created_at" label="Create Time" align="center"></el-table-column>
                <el-table-column prop="noti_type" label="Alarm Mode" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.noti_type_name }}
                        <!-- <span v-for="item in scope.noti_type_name">{{
                    scope
                }}</span> -->
                    </template>
                </el-table-column>
                <el-table-column prop="handle_reason" label="Cause Description" align="center"></el-table-column>
                <el-table-column prop="handle_action" label="Operation Description" align="center"></el-table-column>
                <el-table-column prop="handler" label="Operator" align="center"></el-table-column>
                <el-table-column prop="handle_at" label="Operated Time" align="center"></el-table-column>
                <el-table-column prop="status_des" label="Current State" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="lookon">{{
                            scope.row.status_des
                        }}</span>
                        <span v-if="scope.row.status == 0" class="lookoff">{{
                            scope.row.status_des }}</span>
                        <span v-if="scope.row.status == 2" class="closeon">{{
                            scope.row.status_des }}</span>
                        <span v-if="scope.row.status == 3" class="overlook">{{
                            scope.row.status_des }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Operations" align="center" width="200">
                    <template slot-scope="scope">

                        <span class="lookDetail" @click="gotodetail(scope.row.id, scope.row.index)"
                            style="color:rgb(64, 224, 208);">
                            View Details
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pag">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40]" :page-size="100" layout="->,total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <!-- <dealdialog :title="dialogtitle" :infoid="infoid" :dealdialogVisible="dealdialogVisible"
            @closedrawer="closedrawer" v-if="dealdialogVisible">
        </dealdialog> -->

    </div>
</template>

<script>

// import dealdialog from '../component/dealdialog.vue'

export default {
    components: {
        // dealdialog
    },
    data() {
        return {
            dealdialogVisible: false,
            warninglist: null,
            form: {
                name: '',
                des: ''
            },
            dialogtitle: null,
            alertAllData: null,
            iconlist: [
            ],
            selectOption1: [
                { id: "-1", name: "ALL" },
                { id: "0", name: "Pending" },
                { id: "1", name: "Processing" },
                { id: "2", name: "Done" },
                { id: "3", name: "Ignored" },
            ],
            selectOption2: [],
            modulesOption: [],
            queryInfo: {
                module: '-1',
                level: '-1',
                type: '-1',
                keywords: "",
                status: '-1',
                pagenum: 1,
                pagesize: 10,
            },
            total: 0,
            states: "",
            modules: "",
            dialogVisible: false,
            changeDialogVisible: false,
            changedata: {},
            serchnum: 0,
            type: 0,
            logVisible: false,
            myrow: null,
            checked: null,
            mycommand: null,
            logtitle: null,
            levellist: null,
            typelist: null,
            modulelist: null
        };
    },
    created() {
        this.getAlllevel()
        this.getAlltype()
        this.getmodulelist()
        this.getall();
    },
    watch: {
        "$route.query.id": {
            handler(val) {
                this.dealdialogVisible = false;
                if (val) {
                    this.infoid = val * 1;
                    this.dialogtitle = 'Reason explanation';
                    this.type = 1;
                    this.dealdialogVisible = true;
                }
            },
            immediate: true,
        }
    },
    methods: {
        async getmodulelist() {
            // this.checked = false
            const { data: res } = await this.$http.get("/alarm/algpub/module/info", {
                mode: -1
            });
            if (res.code == 200) {
                this.modulelist = res.data
                this.modulelist.push(
                    {
                        id: "-1", name: "ALL"
                    }
                )
            }
        },
        async getAlllevel() {
            const { data: res } = await this.$http.get("/alarm/level/used/all?mode=1");
            console.log(res.data);
            this.levellist = res.data
            this.levellist.push(
                {
                    id: "-1", name: "ALL"
                }
            )
        },

        async getAlltype() {
            const { data: res } = await this.$http.get("/alarm/type/used/all?mode=1");
            console.log(res.data);
            this.typelist = res.data
            this.typelist.push(
                {
                    id: "-1", name: "ALL"
                }
            )
        },

        async getall() {
            this.checked = false
            const { data: res } = await this.$http.get("/alarm/record/list", {
                params: this.queryInfo,
            });
            if (res.code == 200) {
                this.warninglist = res.data.data;
                this.total = res.data.total_count;
            }
        },

        resetSearch() {
            this.queryInfo.pagenum = 1;
            this.queryInfo.status = '-1';
            this.queryInfo.keywords = "";
            this.queryInfo.module = '-1';
            this.queryInfo.level = '-1';
            this.queryInfo.type = '-1';
            this.serchnum = 0;
            this.getall();
        },

        async lookDetail(row, type) {
            this.infoid = row.id
            if (type == 'deal') {
                this.dialogtitle = 'Reason explanation';
                this.type = 1;
                this.dealdialogVisible = true;
            } else {
                this.dialogtitle = 'Reason explanation';
                this.type = 1;
                this.dealdialogVisible = true;
            }
        },
        filterHandler(value, row, column) {
            const property = column["property"];
            return row[property] === value;
        },


        handleClose() {
            this.getall();
            this.dialogVisible = false
        },
        Closelog() {
            this.myrow = null;
            this.mycommand = null;
            this.getall();
            this.logVisible = false
        },

        serchAllRuleData() {
            this.getall();
        },
        handleSizeChange(val) {
            this.queryInfo.pagesize = val
            this.getall();

        },
        handleCurrentChange(val) {
            this.queryInfo.pagenum = val
            this.getall();

        },
        clickcheck() {
            console.log(this.checked);
            if (this.checked) {
                this.toggleSelection(this.warninglist)
            } else {
                this.toggleSelection()
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.usertable.toggleRowSelection(row);
                });
            } else {
                this.$refs.usertable.clearSelection();
            }
        },
        closedrawer() {
            this.dealdialogVisible = false;
            if (this.$route.query.id) {
                this.$router.push("/warningCenter");
            }
            this.getall();
        },
        gotodetail(detailId, index) {
            this.$router.push({
                path: "/alertDetail",
                query: { id: detailId, index: index },
            });
            // console.log(detailId);
        },

        gotoBefore() {
            this.gotoid = window.sessionStorage.getItem("waringid");
            if (this.from == 'control') {
                this.$router.push({
                    path: "/openMore",
                    query: { index: this.modulesIndex },
                });
            } else {
                this.$router.go(-1);
            }
        },
        clickOutSide1() {
            this.$refs.select1.blur()
        },
        clickOutSide2() {
            this.$refs.select2.blur()
        },
        clickOutSide3() {
            this.$refs.select3.blur()
        },
        clickOutSide4() {
            this.$refs.select4.blur()
        },
        clickOutSide() {
            this.$refs.select.blur()
        },
    },
};
</script>

<style lang="scss" scoped>
.warninglv {
    background-color: rgb(33, 33, 33);
}

.Breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18.75px;
    color: rgb(204, 204, 204);

    .path {
        font-size: 14px;
        margin-left: 6px;
        margin-right: 6px;
    }

    .now {
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0px;
        line-height: 18.75px;
        color: rgb(64, 224, 208);
        text-align: left;
        vertical-align: top;
    }
}

.Description {
    margin: 25px;
    margin-top: 0px;
    padding-top: 36px;

    .el-input {
        width: 25%;
    }

    .addButton {
        margin-left: 0 !important;
    }
}

h2 {
    margin-top: 0px;
    margin-bottom: 30px;
}

.center {
    margin: 25px;
    height: 800px;
    overflow-x: hidden;
    overflow-y: auto;
}

.el-input {
    display: inline-block !important;
    width: 25%;
}

.check_box {
    margin-right: 30px;
}

.iconbox {
    margin-right: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        height: 21px;
        margin-right: 6px;
    }
}

.state {
    margin-left: 40px;
    color: rgb(64, 224, 208);
}

.warningInput {
    width: 20%;
}

.btn_box {
    margin-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.stateSelect {
    width: 8%;
}

.module {
    margin-top: 20px;
    width: 25%;
}

::v-deep .el-table th.is-leaf {
    height: 60px;
    font-size: 15px;
    background: rgba(36, 102, 168, 0.1);
    color: rgb(64, 224, 208);
    border: none;
}

::v-deep .el-table__body {
    //-webkit-border-horizontal-spacing: 13px;  // 水平间距
    -webkit-border-vertical-spacing: 20px; // 垂直间距
}

::v-deep .el-table,
.el-table__expanded-cell {
    background-color: transparent
}

::v-deep .el-table::before {
    height: 0;
}

::v-deep .el-button--primary {
    background-color: rgb(0, 128, 128) !important;
    border-color: rgb(0, 128, 128) !important;
}

.searchButton {
    background-color: rgb(0, 128, 128);
    border-color: rgb(0, 128, 128);
    margin-left: 50px !important;
}

.resetButton {
    margin-left: 30px !important;
}

.el-pagination {
    margin-top: 40px;
    margin-left: 20px;
    margin-bottom: 20px;
}

.stop_text {
    color: rgba(255, 141, 26, 1);
}

.delete_text {
    color: rgba(184, 75, 75, 1);
}

.lookon {
    display: inline-block;
    color: rgba(36, 102, 168, 1);
    width: 88px;
    height: 36px;
    line-height: 36px;
    opacity: 1;
    border-radius: 68px;
    background: rgba(36, 102, 168, 0.1);
}

.lookoff {
    display: inline-block;
    color: rgba(103, 103, 103, 1);
    width: 88px;
    line-height: 36px;
    height: 36px;
    opacity: 1;
    border-radius: 68px;
    background: rgba(230, 231, 236, 1);
}

.closeon {
    display: inline-block;
    color: rgba(255, 255, 255, 1);
    width: 88px;
    line-height: 36px;
    height: 36px;
    opacity: 1;
    border-radius: 68px;
    background: rgb(76, 194, 164);
}

.overlook {
    display: inline-block;
    color: rgba(255, 255, 255, 1);
    width: 88px;
    line-height: 36px;
    height: 36px;
    opacity: 1;
    border-radius: 68px;
    background: #797b80;
}

::v-deep .el-dialog__footer {
    border-top: 1px solid rgba(219, 219, 219, 1);
}

::v-deep .el-dialog {
    opacity: 1;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
}

.prj_content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .about {
        color: rgba(36, 102, 168, 1);
    }
}

::v-deep .el-table td.el-table__cell div {

    display: flex;
    justify-content: center; //水平
    align-items: center; //垂直
}


.lookDetail {
    cursor: pointer;
    // margin-right: 30px;
    line-height: 26px;
    display: flex;
    justify-content: center; //水平
    align-items: center; //垂直

    img {
        height: 16px;
        margin-right: 6px;
    }
}

.pag {
    padding-bottom: 10px;
    margin-right: 25px;
}

::v-deep .el-pager li {
    width: 40px;
    height: 40px;
    opacity: 1;
    margin-left: 16px;
    margin-right: 16px;
    line-height: 40px;
    border-radius: 50%;
    color: rgba(103, 103, 103, 1);
    background: #E6E7EC;
}

::v-deep .el-pager li.active {
    color: rgba(255, 255, 255, 1);
    background-color: rgba(36, 102, 168, 1);
    cursor: default;
}

::v-deep .el-pagination .btn-prev {
    width: 40px;
    height: 40px;
    opacity: 1;
    border-radius: 50%;
    background: rgba(244, 246, 251, 1);
    border: 1px solid rgba(230, 231, 236, 1);
}

::v-deep.el-pagination .btn-next {
    width: 40px;
    height: 40px;
    opacity: 1;
    border-radius: 50%;
    background: rgba(244, 246, 251, 1);
    border: 1px solid rgba(230, 231, 236, 1);
}

::v-deep .el-pagination__jump {
    height: 40px;
    line-height: 40px !important;
    font-size: 16px !important;
    vertical-align: middle !important;
}

::v-deep .el-pagination__total {
    font-size: 16px !important;
    line-height: 40px !important;
    font-size: 16px !important;
    vertical-align: middle !important;
}

::v-deep .el-pagination__sizes {
    font-size: 16px !important;
    line-height: 40px !important;
    font-size: 16px !important;
    vertical-align: middle !important;
}

::v-deep .el-input__inner {
    border-radius: 20px;
}

::v-deep .el-textarea {
    width: 97%;
}
</style>
